import { render, staticRenderFns } from "./tuinontwerp.vue?vue&type=template&id=593f7afc"
import script from "./tuinontwerp.vue?vue&type=script&lang=js"
export * from "./tuinontwerp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports